import api from './config'

export function fetchAbout() {
  return api('/texts/');
}
